export interface IPlaidOptions {
  clientName: string;
  env: string;
  key: string;
  language: string;
  product: string[];
  selectAccount: boolean;
  onSuccess: (publicToken: string, metadata?: any) => void;
  onLoad?: () => void;
  onExit?: (err: any, metadata?: any) => void;
  onEvent?: (eventName: string, metadata?: any) => void;
  webhook?: string;
}

export enum PlaidEnvironmentsEnum {
  sandbox = 'sandbox',
  development = 'development',
  production = 'production',
}

export interface IPlaidAccountMetadata {
  account: IPlaidAccountInfo; // Info of the account selected for payment
  account_id: string;
  accounts: IPlaidAccountInfo[]; // All the accounts associated with the user
  institution: {
    institution_id: string;
    name: string;
  };
  link_session_id: string;
  public_token: string;
}

export interface IPlaidAccountInfo {
  id: string;
  mask: string;
  name: string;
  subtype: string;
  type: string;
}

export const PLAID_KEY = '781b844f22c6372bacdd231c394429';
